import axios from 'axios'

// 创建 axios 实例，baseURL 由环境变量注入（无需手动改代码切换环境）：
//   npm run serve        读取 .env.development -> http://127.0.0.1:8888/api（本地）
//   npm run build:dev    读取 .env.dev         -> http://www.bqbt.cn:8082/api（开发环境）
//   npm run build:prod   读取 .env.prod        -> http://www.bqbt.cn/api（生产环境）
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000    // 请求超时时间，单位为毫秒
})

// 请求拦截器：自动携带 token
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器：统一处理错误
service.interceptors.response.use(
    response => response.data,
    error => {
        console.error('请求出错：', error)
        return Promise.reject(error)
    }
)

export default service
